import { preloadIntentBasedOnboardingState } from '@confluence/onboarding-helpers/entry-points/preloadIntentBasedOnboardingState.ts';
import { preloadGetLicensedProductsQuery } from '@confluence/onboarding-helpers/entry-points/preloadGetLicensedProductsQuery.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import type { onboardingStateGetOnboardingStateQuery$data } from '@confluence/onboarding-helpers/entry-points/onboardingStateGetOnboardingStateQuery.ts';
import type { GraphQLError } from 'graphql';

type LicensedProductsQueryData =
	Awaited<ReturnType<typeof preloadGetLicensedProductsQuery>> extends { data: infer T } ? T : null;

export const preloadIntentBasedOnboarding = (): Promise<
	| void
	| Error[]
	| (
			| {
					data: onboardingStateGetOnboardingStateQuery$data | null;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
			| {
					data: LicensedProductsQueryData;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
	  )[]
> => {
	return waitForAllReturnWhenError([
		preloadIntentBasedOnboardingState(),
		preloadGetLicensedProductsQuery(),
	]);
};
